module.exports = __webpack_public_path__ + "img/35bef6d643bd40c2848ef89523ca7d22.b2202761.png";